// Copy from https://github.com/cameronhimself/vue-drag-drop

import Drag from './Drag.vue';
import Drop from './Drop.vue';

// Install the components
export function install (Vue) {
  Vue.component('drag', Drag);
  Vue.component('drop', Drop);
}

// Expose the components
export { Drag, Drop };

/* -- Plugin definition & Auto-install -- */
/* You shouldn't have to modify the code below */

// Plugin
const plugin = {
  /* eslint-disable no-undef */
  version: '1.1.4',
  install,
};

export default plugin;
